import Modal from '../../../../../../commons/Modal/Modal';
import { UpdateStatusProspectModalProps } from './UpdateStatusProspectModal.types';
import UpdateStatusProspectForm from './UpdateStatusProspectForm/UpdateStatusProspectForm';
import { ModalSizes } from '../../../../../../commons/Modal/Modal.types';

export default ({ prospect, ...props }: UpdateStatusProspectModalProps) => {
  // const { mutate } = useMutation<Awaited<BaseResponse>, Error, UpdateProspectStatusQueryParams>(
  //   (data) => updateProspectStatusQuery(data),
  //   {
  //     mutationKey: UPDATE_PROSPECT_STATUS_QUERY_KEY,
  //     onMutate: () => queryClient.cancelMutations(),
  //     onSuccess: ({ message }) => {
  //       alert(message);
  //     },
  //     onError: async (error) => alert(error.message),
  //   }
  // );

  if (!prospect) return null;

  return (
    <Modal closeOnClickOutside size={ModalSizes.Large} {...props}>
      <UpdateStatusProspectForm {...{ prospect }} />
    </Modal>
  );
};
